import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ru from '@/locales/ru.json'
import en from '@/locales/en.json'

const STORAGE_KEY = 'stryzh.lang'

/** Язык при старте: из localStorage (выбор пользователя), иначе ru. */
function initialLang(): 'ru' | 'en' {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'en' ? 'en' : 'ru'
  } catch {
    return 'ru'
  }
}

void i18n.use(initReactI18next).init({
  resources: { ru: { translation: ru }, en: { translation: en } },
  lng: initialLang(),
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
})

// Persist выбора языка. Переключатель зовёт i18n.changeLanguage(lng) — здесь
// сохраняем, чтобы выбор пережил перезагрузку.
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng)
  } catch {
    // localStorage недоступен (приватный режим) — молча игнорируем
  }
})

export default i18n
